import { WebTrackerConfig } from "./types";

const defaultConfig: WebTrackerConfig = {
  defaults: "2025-05-24",
};

export { defaultConfig };
